<script>
import axios from "axios";
import SenderForm from "./SenderForm.vue";
import { toast, variants } from "@/helpers/toaster";

export default {
  name: "CityExpressSenderList",
  components: { SenderForm },
  data() {
    return {
      loading: false,
      senders: [],
      showModal: false,
      editing: null,
      fields: [
        { key: "name", label: "Naziv" },
        { key: "street_and_number", label: "Adresa" },
        { key: "zipcode", label: "PB" },
        { key: "city", label: "Grad" },
        { key: "country_code", label: "Država" },
        { key: "phone", label: "Telefon" },
        { key: "is_default", label: "Podrazumevan" },
        { key: "actions", label: "" },
      ],
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await axios.get("/super-admin/city-express/senders");
        this.senders = data.data || [];
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.editing = null;
      this.showModal = true;
    },
    openEdit(sender) {
      this.editing = { ...sender };
      this.showModal = true;
    },
    async remove(sender) {
      if (!confirm(`Obrisati pošiljaoca "${sender.name}"?`)) return;
      await axios.delete(`/super-admin/city-express/senders/${sender.id}`);
      toast("Pošiljalac obrisan.", variants.SUCCESS);
      await this.load();
    },
    async sync() {
      this.loading = true;
      try {
        const { data } = await axios.get(
          "/super-admin/city-express/senders/sync",
        );
        const upserted = (data.data && data.data.upserted) || 0;
        toast(`Sinhronizovano ${upserted} pošiljalaca.`, variants.SUCCESS);
        await this.load();
      } finally {
        this.loading = false;
      }
    },
    async onSaved() {
      this.showModal = false;
      this.editing = null;
      await this.load();
    },
  },
};
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <b-button
          variant="outline-secondary"
          @click="sync()"
          :disabled="loading"
        >
          <i class="fas fa-sync-alt mr-1" /> Sinhronizuj iz CE
        </b-button>
      </div>
      <b-button variant="primary" @click="openCreate()">
        <i class="fas fa-plus mr-1" /> Novi pošiljalac
      </b-button>
    </div>

    <b-table
      :items="senders"
      :fields="fields"
      :busy="loading"
      small
      striped
      responsive
    >
      <template #cell(is_default)="row">
        <b-badge v-if="row.item.is_default" variant="success">DA</b-badge>
        <span v-else class="text-muted">—</span>
      </template>
      <template #cell(actions)="row">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="openEdit(row.item)"
        >
          Izmeni
        </b-button>
        <b-button
          size="sm"
          variant="outline-danger"
          class="ml-1"
          @click="remove(row.item)"
        >
          Obriši
        </b-button>
      </template>
      <template #empty>
        <div class="text-center text-muted py-3">Nema pošiljalaca.</div>
      </template>
    </b-table>

    <b-modal
      v-model="showModal"
      :title="editing ? 'Izmena pošiljaoca' : 'Novi pošiljalac'"
      hide-footer
      size="lg"
    >
      <sender-form
        :sender="editing"
        @saved="onSaved"
        @cancel="showModal = false"
      />
    </b-modal>
  </div>
</template>
